module.exports = {
  title: "InventSys - Перфект Плюс ЕООД",
  apiBaseURL: "http://localhost:9002/",
  apiRFIDBaseURL: "http://localhost:5000/api/Rfid/",
  domain: "is.perfectbg.com",
  version: 'InventSys Perfect V3 LP',
  requestTimeout: 5, // in minutes
  removeTokenAfterBrowserClose: true,
  RFIDReloadIntervals: {
    deviceInfoInterval: 120000,
    tagLocatePercentageInterval: 350,
    tagInventoryInterval: 3000
  },
  defaults: {
    
  }
}
